/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
 * @restrict E
 * @description Widget che visualizza i dati e lo stato dell'affidamento specificato, e permette l'esecuzione delle oeprazioni di blocco e sblocco
 * @param {number} id-affidamento - Identificativo univoco dell'affidamento
 */
(function() {
	"use strict";
	angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasDettaglioAffidamento", [ 'CONSTANTS', function(CONSTANTS) {
		
		var controller = function($scope, labelSrvc, $q, $http, $uibModal, CreasMessaggiFctr) {
			this.$uibModal = $uibModal;
			$scope.msg = labelSrvc.getLabel;
			
			this.pratica = null;
			this.spinner = {
				widget: false,
				operazione: false
			};
			
			var self = this;
			
			/**
			 * @ngdoc method
			 * @name promiseBloccoAffidamento
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
			 * @description Effettua una chiamata http per eseguire il blocco dell'affidamento specificato
			 * @return {Promise} - Ritorna una promise contenente l'esito del blocco
			 */
			this.promiseBloccoAffidamento = function() {    		
    			return $http({
    				method: 'GET',
    				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.AFFIDAMENTI.FIDO + self.pratica.fidoNonOperativo.idFidoNonOperativoPMI + '/blocca'
    			});
    		}
			
			/**
			 * @ngdoc method
			 * @name promiseSbloccoAffidamento
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
			 * @description Effettua una chiamata http per eseguire lo sblocco dell'affidamento specificato
			 * @return {Promise} - Ritorna una promise contenente l'esito dello sblocco
			 */
			this.promiseSbloccoAffidamento = function() {    		
    			return $http({
    				method: 'GET',
    				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.AFFIDAMENTI.FIDO + self.pratica.fidoNonOperativo.idFidoNonOperativoPMI + '/sblocca'
    			});
    		}
			
			/**
			 * @ngdoc method
			 * @name promiseAffidamento
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
			 * @description Effettua una chiamata http per recuperare i dati dell'affidamento specificato
			 * @return {Promise} - Ritorna una promise contenente i dati dell'affidamento specificato
			 */
			this.promiseAffidamento = function() {    		
    			return $http({
    				method: 'GET',
    				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.AFFIDAMENTI.FIDOPERNDG + $scope.ndg
    			});
    		}
        	
			/**
			 * @ngdoc method
			 * @name caricaAffidamento
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
			 * @description Recupera i dati dell'affidamento specificato
			 */
			this.caricaAffidamento = function() {
				self.spinner.widget = true;
				
				if (!$scope.ndg) {
					self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettaglioaffidamento.nondg') });
					return;
				}
				
				$q.all({
					affidamento: self.promiseAffidamento(),
				}).then(function(response) {
					if (CreasMessaggiFctr.processaResponse(response.affidamento)) {
						self.pratica = null;
						return;
					}
					
					self.pratica  = response.affidamento.data.result;
				}, function(reason) {
					CreasMessaggiFctr.processaResponse(reason.affidamento);
					self.pratica = null;
				}).finally(function() {
					self.spinner.widget = false;
				});
			}
			
			/**
			 * @ngdoc method
			 * @name bloccaAffidamento
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
			 * @description Richiede conferma e, in caso affermativo, esegue il blocco dell'affidamento specificato
			 */
			this.bloccaAffidamento = function() {
				
				var modalController = function($scope, LabelSrvc, $modalInstance) {
                	
                	$scope.headerText = LabelSrvc.getLabel('label.dettaglioaffidamento.confirm.header');
                	$scope.bodyText = LabelSrvc.getLabel('label.dettaglioaffidamento.confirm.blocco');
                	$scope.cancelText = LabelSrvc.getLabel('button.dettaglioaffidamento.confirm.cancel');
                	$scope.confirmText = LabelSrvc.getLabel('button.dettaglioaffidamento.confirm.confirm');
                	
                	$scope.optionSelected = function(result) {
                		$modalInstance.close(result);
                	}
                	
                };
                
                modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
				
				var modalInstance = this.$uibModal.open({
	                animation: true,
	                template: '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
	                backdrop: 'static',
	                size: 'lg',
	                controller: modalController
	            });
				
				modalInstance.result.then(function (confirmResult) {
					
					if (confirmResult !== true) {
						return;
					}
					
					// Eseguo il blocco
					self.spinner.operazione = true;
					
					$q.all({
						affidamento: self.promiseBloccoAffidamento(),
					}).then(function(response) {
						if (CreasMessaggiFctr.processaResponse(response.affidamento)) {
							return;
						}
						
						if (response.affidamento.data && response.affidamento.data.result) {
							self.pratica  = response.affidamento.data.result;
						}
					}, function(reason) {
						CreasMessaggiFctr.processaResponse(reason.affidamento);
						self.caricaAffidamento();
					}).finally(function() {
						self.spinner.operazione = false;
					});
					
				});
				
			}
			
			/**
			 * @ngdoc method
			 * @name sbloccaAffidamento
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioAffidamento
			 * @description Richiede conferma e, in caso affermativo, esegue lo sblocco dell'affidamento specificato
			 */
			this.sbloccaAffidamento = function() {
				
				var modalController = function($scope, LabelSrvc, $modalInstance) {
                	
                	$scope.headerText = LabelSrvc.getLabel('label.dettaglioaffidamento.confirm.header');
                	$scope.bodyText = LabelSrvc.getLabel('label.dettaglioaffidamento.confirm.sblocco');
                	$scope.cancelText = LabelSrvc.getLabel('button.dettaglioaffidamento.confirm.cancel');
                	$scope.confirmText = LabelSrvc.getLabel('button.dettaglioaffidamento.confirm.confirm');
                	
                	$scope.optionSelected = function(result) {
                		$modalInstance.close(result);
                	}
                	
                };
				
				modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
				
				var modalInstance = this.$uibModal.open({
	                animation: true,
	                template: '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
	                backdrop: 'static',
	                size: 'lg',
	                controller: modalController
	            });
				
				modalInstance.result.then(function (confirmResult) {
					
					if (confirmResult !== true) {
						return;
					}
					
					// Eseguo lo sblocco
					self.spinner.operazione = true;
					
					$q.all({
						affidamento: self.promiseSbloccoAffidamento(),
					}).then(function(response) {
						if (CreasMessaggiFctr.processaResponse(response.affidamento)) {
							return;
						}
						
						if (response.affidamento.data && response.affidamento.data.result) {
							self.pratica  = response.affidamento.data.result;
						}
					}, function(reason) {
						CreasMessaggiFctr.processaResponse(reason.affidamento);
						self.caricaAffidamento();
					}).finally(function() {
						self.spinner.operazione = false;
					});
					
				});
				
			}
			
			self.caricaAffidamento();
			
		};

		controller.$inject = ['$scope', 'LabelSrvc', '$q', '$http', '$uibModal', 'CreasMessaggiFctr'];
		
		return {
			restrict : "E",
			scope : {
				ndg: '<'
			},
			templateUrl : CONSTANTS.BASE_ROOT + "widgets/creasDettaglioAffidamento/creasDettaglioAffidamento.html",
			controller: controller,
			controllerAs: "creasDettaglioAffidamentoCtrl",
		};
	}]);
}());


//////////////////
// WEBPACK FOOTER
// ./app/widgets/creasDettaglioAffidamento/creasDettaglioAffidamentoDrct.js
// module id = 10
// module chunks = 0 1